/**
 * Fly-to-cart animation. Call after yielding the main thread (see yieldToMain)
 * so layout reads do not extend the click Long Task.
 */
export const cartAnimation = (event: any) => {
  const getClosest = function (elem: any, selector: any) {
    for (; elem && elem !== document; elem = elem.parentNode) {
      if (elem.matches(selector)) return elem;
    }
    return null;
  };

  const imgToDrag = getClosest(event.target, '.product-card');
  if (!imgToDrag) return;

  const viewCart = document.getElementsByClassName('product-cart')[0] as
    | HTMLElement
    | undefined;
  const imgToDragImage = imgToDrag.querySelector('.product-image') as
    | HTMLElement
    | null;

  if (!viewCart || !imgToDragImage) return;

  // Batch layout reads before any DOM writes
  const cardRect = imgToDrag.getBoundingClientRect();
  const cartRect = viewCart.getBoundingClientRect();

  const image = imgToDragImage.cloneNode(true) as HTMLElement;
  image.style.cssText =
    'z-index: 11111; width: 100px; opacity: 1; position: fixed; top: ' +
    cardRect.top +
    'px; left: ' +
    cardRect.left +
    'px; transition: left 1s, top 1s, width 1s, opacity 1s cubic-bezier(1, 1, 1, 1); border-radius: 50px; overflow: hidden; box-shadow: 0 21px 36px rgba(0,0,0,0.1)';

  const reChange = document.body.appendChild(image);
  setTimeout(function () {
    image.style.left = cartRect.left + 'px';
    image.style.top = cartRect.top + 'px';
    image.style.width = '40px';
    image.style.opacity = '0';
  }, 200);
  setTimeout(function () {
    reChange.parentNode?.removeChild(reChange);
  }, 1000);
};
